import { Component, input, ChangeDetectionStrategy, effect } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Content, Folder, Genus } from '@xanadu/model';
import { dateRangeValidator } from '../../input/validator/date-range-validator';

@Component({
    selector: 'app-publish',
    templateUrl: './publish.component.html',
    styleUrls: ['./publish.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublishComponent {
    formGroup = input<FormGroup>();
    node = input<Content | Folder | Genus>();

    public metaHidden: any = { id: 'hidden', name: 'Hide content' };
    public metaTimeOn: any = { id: 'timeOn', name: 'Scheduled future publish time', info: 'Publish time is ignored if hide content is set to true.' };
    public metaTimeOff: any = { id: 'timeOff', name: 'Scheduled future unpublish time', info: 'Unpublish time is ignored if hide content is set to true.' };
    public formPublish: FormGroup =new FormGroup({}, { validators: dateRangeValidator('timeOn', 'timeOff') });

    constructor() {
        effect(() => {
            const formGroup = this.formGroup();

            if (formGroup) {
                this.formPublish = new FormGroup({}, { validators: dateRangeValidator('timeOn', 'timeOff') });
                this.formGroup()?.addControl('publish', this.formPublish);
            }
        });
    }
}
